import { redact } from './redaction';

type Level = 'debug' | 'info' | 'warn' | 'error';

/** Thin logger that redacts PII and is the single seam for shipping logs later. */
function log(level: Level, message: string, context?: Record<string, unknown>): void {
  const safe = context ? redact(context) : undefined;
  // eslint-disable-next-line no-console -- the one sanctioned console seam
  console[level](`[${level}] ${message}`, safe ?? '');
}

export const logger = {
  debug: (m: string, c?: Record<string, unknown>) => log('debug', m, c),
  info: (m: string, c?: Record<string, unknown>) => log('info', m, c),
  warn: (m: string, c?: Record<string, unknown>) => log('warn', m, c),
  error: (m: string, c?: Record<string, unknown>) => log('error', m, c),
};
